import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GraduationCap, Menu, User, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetClose } from '../ui/sheet';
import { NAV_LINKS, scrollToSection } from './landingData';

export default function LandingNavbar() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleNav = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header className="sticky top-0 z-30 border-b border-white/10 bg-[#050816]/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-blue-500/30 bg-blue-600/20 shadow-[0_0_0_1px_rgba(59,130,246,0.25)]">
            <GraduationCap className="h-5 w-5 text-blue-400" />
          </div>
          <div className="min-w-0">
            <p className="font-semibold leading-tight text-white">School Analytics</p>
            <p className="text-xs text-white/50">School management system</p>
          </div>
        </div>

        <nav className="hidden items-center gap-6 text-sm text-white/70 md:flex">
          <button
            type="button"
            className="relative transition-colors hover:text-white after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-white/60 after:transition-all hover:after:w-full"
            onClick={() => navigate('/login')}
          >
            Login
          </button>
          <button
            type="button"
            className="relative transition-colors hover:text-white after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-white/60 after:transition-all hover:after:w-full"
            onClick={() => navigate('/register')}
          >
            Register
          </button>
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              type="button"
              className="relative transition-colors hover:text-white after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-white/60 after:transition-all hover:after:w-full"
              onClick={() => handleNav(link.id)}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 text-white/70 transition-colors hover:bg-white/10 hover:text-white md:hidden"
            onClick={() => navigate('/login')}
            aria-label="Login"
          >
            <User className="h-4 w-4" />
          </button>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                type="button"
                className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 text-white/70 transition-colors hover:bg-white/10 hover:text-white md:hidden"
                aria-label="Open menu"
              >
                <Menu className="h-4 w-4" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="border-white/10 bg-[#050816] text-white">
              <SheetHeader>
                <SheetTitle className="text-white">Menu</SheetTitle>
              </SheetHeader>
              <nav className="mt-6 flex flex-col gap-1">
                <SheetClose asChild>
                  <button
                    type="button"
                    className="rounded-lg px-3 py-2.5 text-left text-sm text-white/80 transition-colors hover:bg-white/10 hover:text-white"
                    onClick={() => navigate('/login')}
                  >
                    Login
                  </button>
                </SheetClose>
                <SheetClose asChild>
                  <button
                    type="button"
                    className="rounded-lg px-3 py-2.5 text-left text-sm text-white/80 transition-colors hover:bg-white/10 hover:text-white"
                    onClick={() => navigate('/register')}
                  >
                    Register
                  </button>
                </SheetClose>
                {NAV_LINKS.map((link) => (
                  <SheetClose key={link.id} asChild>
                    <button
                      type="button"
                      className="rounded-lg px-3 py-2.5 text-left text-sm text-white/80 transition-colors hover:bg-white/10 hover:text-white"
                      onClick={() => handleNav(link.id)}
                    >
                      {link.label}
                    </button>
                  </SheetClose>
                ))}
              </nav>
            </SheetContent>
          </Sheet>

          <Button
            variant="outline"
            className="hidden border-white/20 bg-transparent text-white hover:bg-white/10 md:inline-flex"
            onClick={() => scrollToSection('features')}
          >
            Learn more
          </Button>
          <Button
            className="hidden bg-blue-600 hover:bg-blue-700 md:inline-flex"
            onClick={() => navigate('/login')}
          >
            Login <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
